module.exports = __webpack_public_path__ + "static/media/buy_req_help_15.1e1beba2.jpg";